<template>
    <Spin :spinning="loading">
        <div class="video-container"
             :class="props.deviceType">
            <video
                ref="videoPlayer"
                class="video-js vjs-matrix vjs-default-skin vjs-big-play-centered work-video vjs-16-9">
            </video>
        </div>
    </Spin>
</template>

<script setup lang="ts">
import {getCurrentInstance, onMounted, onUnmounted, ref} from "vue";
import videoJs from "video.js/core.es.js"
import videoLangJson from 'video.js/dist/lang/zh-CN.json'
import {Spin} from "ant-design-vue";
import http from "@/utils/http";
import {notify, route} from "@/utils/common";

videoJs.addLanguage('zh-CN', videoLangJson)

const videoPlayer = ref(null)
const myPlayer = ref(null)

const props = withDefaults(defineProps<{
    file_id: any,
    deviceType?: 'default' | 'mobile'
}>(), {
    deviceType: 'default'
})

const loading = ref(true)
const ins = getCurrentInstance()
const getPreviewUrl = async () => {
    const res = await http.get(route('api.videoUpload.getFileUrl') + '?file_id=' + props.file_id)

    if (res.data.url) {
        return res.data.url
    }

    notify({
        message: '视频转码中，请稍后查看'
    })
    await (new Promise(resolve => {
        setTimeout(() => {
            resolve(1)
        }, 5000)
    }))
    return await getPreviewUrl()

}
const src = ref('')

onMounted(async () => {
    const url = await getPreviewUrl()
    loading.value = false

    myPlayer.value = videoJs(videoPlayer.value, {
        controls: true,
        autoplay: true,
        preload: 'auto',
        fluid: true,
        language: 'zh-CN',
        sources: [
            {src: url}
        ],
        playbackRates: [0.5, 1, 1.5, 2, 4],

        controlBar: {
            currentTimeDisplay: true,
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: true,
            volumePanel: {
                inline: false,
            },
            children: [
                {name: 'playToggle'}, // 播放/暂停按钮
                {name: 'progressControl'}, // 播放进度条
                {name: 'currentTimeDisplay'}, // 视频播放总时间
                {name: 'remainingTimeDisplay'}, // 视频播放总时间
                {
                    name: 'volumePanel', // 音量控制
                    inline: false, // 不使用水平方式
                },
                {name: 'playbackRateMenuButton'},
                {name: 'pictureInPictureToggle'},
                {name: 'FullscreenToggle'}, // 全屏
            ],
        },
    })
    myPlayer.value.on('error', async (e) => {
        const url = await getPreviewUrl()
        const currentTime = myPlayer.value.currentTime()
        myPlayer.value.src(url)
        myPlayer.value.currentTime(currentTime)
    })
})

onUnmounted(() => {
    if (myPlayer.value) {
        myPlayer.value.dispose()
    }
})

</script>

<style lang="less">
@import "video.js/dist/video-js.min.css";
@import "@/../css/icons.less";

.video-container {
    width: 600px;
    height: 360px;
    margin: 10px auto 0 auto;
    overflow: hidden;
    /* Change all text and icon colors in the player. */

    &.mobile {
        width: 100%;
        height: unset;
    }

    .video-js {
        width: 100%;
        max-height: 100%;
        overflow: hidden;

        /* Change the border of the big play button. */

        .vjs-big-play-button {
            border: none;
            background-color: transparent;

            .vjs-icon-placeholder {
                .icon.player-big-play;
            }

            &:hover {
                filter: drop-shadow(0 0 4px #FFFFFF);
            }
        }

        .vjs-control-bar {
            background-color: rgba(0, 0, 0, 0.5);
            padding: 0 10px;
            font-size: 12px;
            /* Change the color of various "bars". */

            .vjs-playing {
                .vjs-icon-placeholder {
                    .icon.player-pause;
                }

                &:hover {
                    filter: drop-shadow(0 0 4px #FFFFFF);
                }
            }

            .vjs-paused {
                .vjs-icon-placeholder {
                    .icon.player-play;

                }

                &:hover {
                    filter: drop-shadow(0 0 4px #FFFFFF);
                }
            }

            .vjs-mute-control {
                .vjs-icon-placeholder {
                    .icon.player-volume;
                }

                &:hover {
                    filter: drop-shadow(0 0 4px #FFFFFF);
                }
            }

            .vjs-fullscreen-control {
                .vjs-icon-placeholder {
                    .icon.player-fullscreen;
                }

                &:hover {
                    filter: drop-shadow(0 0 4px #FFFFFF);
                }
            }

            .vjs-volume-level::before {
                top: -.5em !important;
            }
        }
    }

    .vjs-has-started .vjs-big-play-button {
        display: block;
    }

    .vjs-playing .vjs-big-play-button {
        display: none;
    }
}

</style>
